import { useBlogCardWebContext } from "./BlogCardWebProvider";
import { CustomChip } from "../../../global/chips/CustomChip";

export const BlogCardObjsContent = () => {
  const { state } = useBlogCardWebContext();
  const objectives = state.blog.objectives;

  if (objectives) {
    return (
      <>
        {objectives.map((objective, i) => {
          return <CustomChip label={objective.title} key={i} />;
        })}
      </>
    );
  }
};
